import activitiesEvents from './events/activities';
import tasksEvents from './events/tasks';
import { getCurrentUserRole } from '../startDate/utils';
import { roleTypes } from '../../../../constants/role.constants';

function events(cell, e, setActivitiesHidden, setCurrentActivityHidden) {
  const { taskId, proplannerId } = cell.dataset;
  const clickedAddTaskButton = e.target.closest('[data-event-add-task]');
  const clickedAddSubTask = e.target.closest('[data-event-add-subtask]');
  const clickedDeleteButton = e.target.closest('[data-event-delete]');
  const clickedRoadblock = e.target.closest('[data-event-roadblock]');
  const clickedCreateTaskFromActivity = e.target.closest(
    '[data-event-create-task]'
  );
  const clickedDuplicateTaskFromActivity = e.target.closest(
    '[data-event-duplicate-task]'
  );
  const clickedHideActivity = e.target.closest('[data-event-hide-activity]');
  const clickedOpenModalMr = e.target.closest('[data-event-open-modal-mr]');

  if (clickedOpenModalMr) {
    const role = getCurrentUserRole();

    const roleOutPermission = [
      roleTypes.SUBTRADE,
      roleTypes.LASTPLANNER,
      roleTypes.MANAGER
    ].includes(role);

    if (roleOutPermission) {
      return;
    }

    activitiesEvents.openScheduleImpactRequestModal(
      taskId,
      'calendar_icon_activity'
    );
  }

  if (clickedAddTaskButton) {
    tasksEvents.addTask(taskId);
    return;
  }

  if (clickedAddSubTask) {
    tasksEvents.addTaskToATask(taskId);
    return;
  }

  if (clickedDeleteButton) {
    tasksEvents.openDeleteTaskTooltip(taskId, clickedDeleteButton);
    e.stopPropagation();
    return;
  }

  if (clickedRoadblock) {
    tasksEvents.openRoadblockModal(taskId);
    return;
  }

  if (clickedCreateTaskFromActivity) {
    const taskIdNumber = Number(taskId);
    activitiesEvents.createTaskFromActivity(taskIdNumber);
    return;
  }

  if (clickedDuplicateTaskFromActivity) {
    activitiesEvents.duplicateActivity(taskId);
    return;
  }

  if (clickedHideActivity) {
    activitiesEvents.hideActivityEvent(
      taskId,
      proplannerId,
      setActivitiesHidden,
      setCurrentActivityHidden
    );
  }
}

export default events;
